module.exports = __webpack_public_path__ + "img/appstore.d3b3c5bdf255.svg";